<template>
  <div>
    <b-container class="mb-5">
      <div class="themes mt-3" v-for="category in publishedChallengeCategories" :key="category.id">
        <b-row>
          <b-col class="my-5 text-center">
            <h2 class="text-light">{{ category.title }}</h2>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="12" sm="12" md="6" lg="4" class="p-3" v-for="theme in publishedThemes(category.themes)" :key="theme.id">
            <div class="card theme-card h-100" @click.stop="$router.push({ name: 'ChallengeTheme', params: { themeId: theme.id }})">
              <div class="card-header border-light theme-header text-center py-5 h-100 d-block">
                <h4 class="title">{{ theme.title }}</h4>
              </div>
              <div class="card-footer border-light text-center">
                <b-button variant="link" :to="{ name: 'ChallengeTheme', params: { themeId: theme.id }}">{{$t('common:view')}}</b-button>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
            <div class="card vote-card--light h-100" v-if="!votes[category.id]">
              <div class="card-header border-light challenge-header text-center p-0 h-100">
                <h5 class="title">{{ $t('challenges:category-feedback-request') }}</h5>
              </div>
              <div class="card-footer border-light text-center mb-3">
                <b-button variant="link" @click.stop="vote({category: category.title, categoryId: category.id}, category.id)"><icon name="thumbs-up" scale="2"/></b-button>
              </div>
            </div>
            <div class="card vote-card--light answered h-100" v-else>
              <div class="card-header border-light challenge-header text-center pt-0 h-100">
                <h5 class="title mb-1">{{ $t('challenges:feedback-thank-you') }}</h5>
              </div>
              <div class="card-footer border-light text-center mb-4">
                <icon name="thumbs-up" scale="2"/>
              </div>
            </div>
          </b-col>
        </b-row>
    </div>
  </b-container>
  <b-container fluid style="background: rgba(55, 119, 113, 0.35);; margin-top: 5rem;">
      <b-row align-h="center">
        <b-col cols="12" md="8" lg="6">
          <div id="feedback-form"  class="mt-4 mb-4 p-4 text-light rounded clearfix" v-if="feedback.sent == false">
            <h4>{{ $t('common:feedback-title') }}</h4>
            <p>{{ $t('common:feedback-body') }}</p>
            <b-form @submit.prevent="sendFeedback">
              <b-form-textarea
                id="textarea"
                v-model="feedback.message"
                :placeholder="$t('common:feedback-placeholder')"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <b-button type="submit" variant="light" class="mt-3 float-right" :disabled="feedback.message.length < 3">{{ $t('common:send') }}</b-button>
            </b-form>
          </div>
          <div id="feedback-form"  class="mt-5 mb-5 p-4 text-light rounded" v-if="feedback.sent == true">
            <h4 class="text-center">{{ $t('common:feedback-thank-you') }}</h4>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Challenges',
  data () {
    return {
      votes: {},
      feedback: {
        message: '',
        sent: false
      }
    }
  },
  watch: {
    language: {
      immediate: true,
      handler (newVal, oldVal) {
        this.$store.dispatch('loadChallengeCategories')
      }
    }
  },
  methods: {
    vote: function (data, id) {
      return new Promise((resolve, reject) => {
        this.axios.post('/feedback/challenge-theme-vote', data).then(response => {
          this.votes[id] = true
          resolve()
          this.$forceUpdate()
        }).catch(err => {
          this.votes[id] = true
          this.$forceUpdate()
          reject(err)
        })
      })
    },
    sendFeedback: function () {
      this.feedback.sent = true
      return new Promise((resolve, reject) => {
        this.axios.post('/feedback/open', { message: this.feedback.message }).then(response => {
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    publishedThemes: function (categoryThemes) {
      if (categoryThemes) {
        return categoryThemes.filter(t => t.title !== undefined).sort((a, b) => (a.order > b.order) ? 1 : -1)
      }
      return []
    }
  },
  computed: {
    ...mapGetters(['language', 'challengeCategories']),
    publishedChallengeCategories: function () {
      if (this.challengeCategories) {
        return this.challengeCategories.filter(c => c.title !== undefined && c.themes.length > 0).sort((a, b) => (a.order > b.order) ? 1 : -1)
      }
      return []
    }
  }
}
</script>
<style lang="scss">
  .theme-card {
    border: none;
    // border-radius: 6px;
    // box-shadow: 0 3px 12px rgba(black, 0.12);
    box-shadow: 0 2px 3px rgba(black, 0.12);
    cursor: pointer;
    // position: relative;
    .tag {
      text-transform: uppercase;
      letter-spacing: 1px;
      font-size: 0.8em;
      font-weight: bold;
      margin-bottom: 1em;
      color: #20a8cc;
    }
    &.locked::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: url('/img/premium-locked.svg'), rgba(#20a8cc, 0.33);
      background-size: auto 2em;
      background-repeat: no-repeat;
      background-position: 1em 1em;
    }
    .theme-header {
      background-color: #4ce0b3;
      background-repeat: no-repeat;
      // background-image: radial-gradient(circle at bottom right, var(--secondary), var(--primary));
      background-image: radial-gradient(circle at bottom right, #ffaf87, #ed6a5e);
      //background-image: url('/img/background-logo.svg'), radial-gradient(circle at center center,rgba(white,0.8), rgba(white,0.6)), radial-gradient(circle at bottom right,#20a8cc, #20a8cc);
      // background-attachment: fixed, fixed;
      background-size: cover;
      background-position: center;
      // height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: var(--white);
      text-shadow: 0 0 2px rgba(white, 0.5);
      .title {
        color: var(--white);
        font-size: 1.5rem;
        margin: 0;
      }
    }
  }
  // .card{
  //   color:black;
  //   background-color: white;
  //   border-radius: 0.25rem;
  //   margin-bottom: 10px;
  //   // padding: 20px;
  //   font-size: 20px;
  // }
  .challenge{
    color:black;
    background-color: white;
    border-radius: 0.25rem;
    margin-bottom: 10px;
    padding: 20px;
    font-size: 20px;
  }

</style>
